export const GET_CASHIERS = 'getCashiers'
export const CREATE_CASHIER = 'createCashier'
export const UPDATE_CASHIER = 'updateCashier'
export const DELETE_CASHIER = 'deleteCashier'